<template>
    <div>
      <div>
          <h1>彩金服务费的比例:</h1>
          <el-input-number v-model="info.pump" :precision="2" :step="0.01" :max="0.10" :min="0.00"></el-input-number>
          <el-button @click="upentPump(info.pump)" type="primary">应用</el-button>
      </div>
        <div class="pool">
            <strong class="text1" v-text="`分池：${jackpoolBili(info.poolFund)}`"></strong>
            <h1 v-text="`总池：${jackpoolBili(info.totalPoolFund)}`"></h1>
        </div>

        <h2 class="title">彩池配置:</h2>
        <el-collapse v-model="activeNames">
            <el-collapse-item
                    v-for="(item,index) of info.settings"
                    :key="item.blindCode"
                    :name="'collapse'+index">
                <template slot="title">
                    {{mangZhuBiLi(item.blindName)}}
                    <div class="inject">
                        <p class="inject-text" v-text="`子池：${jackpoolBili(item.childPoolFund)}`"></p>
                        <el-button
                                :key="item.blindCode"
                                type="primary"
                                size="small"
                                @click.stop="showPopup(item.childPoolId)">注入
                        </el-button>
                    </div>
                </template>
                <comp-pool-set :info="item"></comp-pool-set>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
    import compPoolSet from './compPoolSet'
    import {mapActions} from "vuex";

    export default {
        components: {
            compPoolSet
        },
        props: {
            info: Object,
        },
        data() {

            return {
                activeNames: ['collapse0'],
            }
        },
        methods: {
          ...mapActions('jackpot', ['updatePumpApi']),
            mangZhuBiLi(val){
              const valNumber=val.split("/");
              let result;
              if (valNumber[1]!=null){
                result='盲注级别'+valNumber[0]/100+'/'+valNumber[1]/100;
              }else {
                result='前注级别'+valNumber[0]/100;
              }
              return result;
            },
          upentPump(pump){
            alert(pump);
            this.updatePumpApi(pump).then(()=>{
              this.$message.success('修改成功');
              this.close()
            })
          },
            jackpoolBili(val){
              return val/100;
            },
            showPopup(poolId){
                this.$emit('my-into',{
                    poolId,
                    marketingAccountFund:this.info.marketingAccountFund
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .text1 {
        font-size: 60px;
    }

    .pool {
        position: relative;
        left: 50%;
        display: inline-block;
        transform: translateX(-50%);
        padding-top: 20px;
        text-align: center;
    }

    .inject {
        position: absolute;
        right: 100px;
        &-text{
            display: inline-block;
            min-width: 180px;
            vertical-align: middle;
            font-size: 16px;
            margin-right: 30px;
        }
        :global(.el-button){
            width: 80px;
        }
    }

    .title {
        padding: 20px 0;
    }

    .common-popup {
        :global(.el-input) {
            width: 150px;
        }
    }
</style>